module.exports = __webpack_public_path__ + "static/media/IMG_20210705_112513_resized_20210705_120407270 (002) (002)-min.072d67e9.jpg";